/** @import { adminMemberResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { identity } from "~/lib/identity.js";

import { alert } from "~/util/alert.js";
/** @import { Placement } from "~/util/float.js"; */
import Query from "~/util/query.js";

import { dropdown } from "~/component/Dropdown.js";

import Roles from "~/admin/lib/roles.js";

/** @typedef {(role: string) => Promise<void>} SubmitCallback */

/**
 * @param {{ anchor: HTMLButtonElement; orgId: string; placement: Placement }} props
 * @param {adminMemberResponse[]} members
 */
export const changeRole = async ({ anchor, orgId, placement }, ...members) => {
	/** @type {SubmitCallback} */
	const onSubmit = async role => {
		await authedApiRequest("PATCH", `/v2/orgs/${orgId}/members`, {
			json: {
				user_ids: members.map(member => member.id),
				role,
			},
		});
	};

	const res = (
		await dropdown({
			anchor,
			placement,
			items: Roles.org.map(role => ({ text: role.label, role })),
		})
	)?.role;
	if (res === undefined) return;

	const title =
		members.length === 1
			? `Update ${members[0]?.name}'s role to ${res.label}?`
			: `Update ${members.length} members' roles to ${res.label}?`;
	if (!(await Roles.confirm(res, title))) return;

	try {
		await onSubmit(res.key);
		Query.invalidate(
			[`/ui/admin/orgs/${orgId}/members`],
			...members.map(member => [`/ui/admin/orgs/${orgId}/members/${member.id}`]),
		);
		if (members.some(member => member.id === identity.me?.id)) {
			Query.invalidate(["/v2/session"], ["/ui/admin/orgs"]);
		}
		return true;
	} catch (err) {
		alert(ApiError.from(err).message, { type: "error" });
		return;
	}
};
